var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4205 13.0022L14.6986 0.28953C14.607 0.19775 14.4982 0.124935 14.3784 0.0752538C14.2586 0.0255725 14.1302 0 14.0006 0C13.8709 0 13.7425 0.0255725 13.6227 0.0752538C13.503 0.124935 13.3942 0.19775 13.3026 0.28953L0.580655 13.0022C0.210024 13.3728 0 13.8762 0 14.4013C0 15.4916 0.886425 16.378 1.9767 16.378H3.31715V25.4492C3.31715 25.9959 3.75881 26.4375 4.30549 26.4375H12.0239V19.5191H15.4831V26.4375H23.6957C24.2423 26.4375 24.684 25.9959 24.684 25.4492V16.378H26.0245C26.5495 16.378 27.053 16.1711 27.4236 15.7973C28.1926 15.0252 28.1926 13.7743 27.4205 13.0022Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0be368858d1fae9127ab14827a893b2b.svg";
export { ForwardRef as ReactComponent };